module.exports = __webpack_public_path__ + "img/delivery1_1.4ef542e5.png";